import type { FunctionComponent } from "react";
import Highlighter from "react-highlight-words";
import { HIGHLIGHT_PROPS } from "components/company/CompanyTable/CompanyName/constants";
import useCompanyCellProps from "./useCompanyCellProps";

export interface CompanyCellProps {
  companyName: string;
  companyContactEmail: string;
  companyContactPhone: string;
}

const CompanyCell: FunctionComponent<CompanyCellProps> = function ({
  companyName,
  companyContactEmail,
  companyContactPhone,
}) {
  const { searchWords, name, email, phone } = useCompanyCellProps(
    companyName,
    companyContactEmail,
    companyContactPhone
  );

  return (
    <div className="flex flex-col text-12-18">
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords}
        textToHighlight={name || ""}
        className="text-12-18-em"
      />
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords}
        textToHighlight={email || ""}
      />
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords}
        textToHighlight={phone || ""}
      />
    </div>
  );
};

export default CompanyCell;
